import IOSConfirmDialog from './IOSConfirmDialog';

export default IOSConfirmDialog;
